var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNonReturnableBlackinline = function SvgNonReturnableBlackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    d: "M7.788 1.765 6.11 4.434l2.597 1.648M16.748 4.04 3.818 17.913"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    d: "M3.13 10.596c0 1.665.593 3.192 1.579 4.381M7.853 4.07A6.9 6.9 0 0 1 10 3.727c1.458 0 2.81.454 3.922 1.228m.968.817a6.87 6.87 0 0 1-9.223 10.155"
  })));
};
export default SvgNonReturnableBlackinline;